export type TrybaShop = {
    name : string,
    clientNumber: string,
    url : string,
    address : string,
    zip : string,
    city : string,
    phone : string | null | undefined,
    latitude : string,
    longitude : string,
}

export type ApiShop = {
    address: string;
    address2: string;
    city: string;
    clientNumber: string;
    createdAt: string;
    htmlTimesheet: string;
    id: number;
    latitude: string;
    longitude: string;
    marketingName: string;
    name: string;
    phone: string;
    phones: string[];
    slug: string;
    state: ShopStateStatusEnum;
    storeLocatorUrl?: string | null;
    subTitle: string;
    timesheet: any;
    updatedAt: string;
    url: string;
    zip: string;
}

export type ShopInfos = {
    marketingName: string,
    name: string,
    address: string,
    city: string,
    phone: string,
    timeSheet: string,
}

export enum ShopStateStatusEnum {
    OPENING = 'opening',
    OPENED = 'opened',
    CLOSED = 'closed',
    BU = 'bu',
}
